export enum ButtonType {
  Submit = 'submit',
  Reset = 'reset',
  Button = 'button',
}
